import React, { useState } from "react";
import axios from "axios";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";
import "./Weather.css";

export default function Weather(props){
    const [city, setCity] = useState(props.defaultCity);
    const [weatherData, setWeatherData] = useState({ready: false});
    function handleResponse(response){
        console.log(response.data);
        setWeatherData({
            ready: true,
            temperature: response.data.main.temp,
            precipitation: response.data.main.precipitation,
            humidity: response.data.main.humidity,
            date: new Date(response.data.dt * 1000),
            description: response.data.weather[0].description,
            icon: response.data.weather[0].icon,
            wind: response.data.wind.speed,
            city: response.data.name,
        })    
    }

    function search(){
    const apiKey = "87a4d33f9276aba60312862a75e60dce";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);

    }

    function handleSubmit(event){
        event.preventDefault();
        search();
        
    }

    function handleCityChange(event){
        setCity(event.target.value);
    }

    if (weatherData.ready) {
        return <div className="Weather">
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-9">
                    <input type="search" placeholder="search for a city..."className="form-control" autoFocus="on" onChange={handleCityChange}/>
                </div>
                <div className="col-3">
                <input type="submit" value="Search" className="btn btn-primary w-200"/>   
                </div>                
            </div>
        </form>
        <WeatherInfo data={weatherData}/>
        <WeatherForecast city={weatherData.city}/>
        
    </div>

} else {

    search();

    return "Be Patient it is Loading :-) ...";

    }
}

    

    

    
